import { getAmplitudeInstance } from '../amplitudeHelpers';
import TourButtonWebLocation from '../enums/TourButtonWebLocation';
import TrailPageType from '../enums/TrailPageType';

type logTrailDetailsTourButtonClickedParams = {
  trail_id?: number;
  trail_page_type?: TrailPageType;
  web_location?: TourButtonWebLocation;
};

/**
 * User clicks the tour button CTA.
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - The trail id of the associated trail details page.
 * @param params.trail_page_type - Type of trail page where the tour button was clicked.
 * @param params.web_location - Web only. Whether the user clicked the tour button from the trail page or gallery.
 */
const logTrailDetailsTourButtonClicked = (
  { trail_id, trail_page_type, web_location }: logTrailDetailsTourButtonClickedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details tour button clicked',
    { 'trail id': trail_id, 'trail page type': trail_page_type, 'web location': web_location },
    callback
  );
};

export default logTrailDetailsTourButtonClicked;
